import { Color, Spacing } from '@persona-id/design-tokens';
import { SlidersIcon } from '@persona-id/design-tokens/icons';
import styled from 'styled-components';

import { Z_INDICES } from 'dashboard/styles/variables';
import { ReportsTableColumns } from 'dashboard/views/DashboardReportsView/ReportsTable';
import Button from 'design-system/components/Button/Button';
import Card from 'design-system/components/Card';
import Popover from 'design-system/components/Popover';
import Spacer from 'design-system/components/Spacer';
import { Heading } from 'design-system/components/Text';
import ToggleSlider from 'design-system/components/ToggleSlider';

const ItemWrapper = styled('div')`
  background: ${Color.BackgroundPrimary};
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.color.border.secondary};
  padding: ${Spacing[2]} ${Spacing[2]};

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
`;

const PopoverCard = styled(Card)`
  width: 300px;
  padding: ${Spacing[4]};
`;

const TriggerIconButton = (props: { 'aria-label'?: string }) => {
  return (
    <Button width='icon' variant='basic' {...props}>
      <SlidersIcon />
    </Button>
  );
};

const SuffixContainer = styled('div')`
  padding-left: ${Spacing[2]};
  margin-left: auto;
  align-self: center;
`;

interface ReportsTableConfigurationDropdownProps {
  toggleFunction: (cn: ReportsTableColumns) => void;
  visibleColumns: Array<ReportsTableColumns>;
}

interface AttributeProps {
  columnName: string;
  handleToggle: () => void;
  toggled: boolean;
  disabled: boolean;
}

const Attribute = ({ columnName, handleToggle, toggled, disabled }: AttributeProps) => {
  return (
    <ItemWrapper>
      <span>{columnName}</span>
      <SuffixContainer>
        <ToggleSlider value={toggled} onChange={handleToggle} disabled={disabled} />
      </SuffixContainer>
    </ItemWrapper>
  );
};

const ReportsTableConfiguration = ({
  toggleFunction,
  visibleColumns,
}: ReportsTableConfigurationDropdownProps) => {
  return (
    <div>
      <Heading size='sm'>Configure columns</Heading>
      <Spacer height={2} />
      {Object.values(ReportsTableColumns).map((columnName) => (
        <Attribute
          key={columnName}
          columnName={columnName}
          toggled={visibleColumns.includes(columnName)}
          handleToggle={() => toggleFunction(columnName)}
          // Do not allow all report columns to be turned off
          disabled={visibleColumns.length === 1 && visibleColumns.includes(columnName)}
        />
      ))}
    </div>
  );
};

const ReportsTableConfigurationDropdown = (props: ReportsTableConfigurationDropdownProps) => {
  return (
    <Popover>
      <Popover.Trigger>
        <TriggerIconButton aria-label='Configure table' />
      </Popover.Trigger>
      <Popover.Content
        style={{ zIndex: Z_INDICES.dropdown }}
        sideOffset={8}
        side='bottom'
        align='end'
      >
        <PopoverCard elevated>
          <ReportsTableConfiguration {...props} />
        </PopoverCard>
      </Popover.Content>
    </Popover>
  );
};

export default ReportsTableConfigurationDropdown;
